// Cómo se llaman en pantalla las cifras que este módulo sabe medir.
//
// Aparte del resto de los textos por un motivo que no es de tamaño: estas claves
// son un CONTRATO con el catálogo de analítica (`backend/analytics.js`), no copia
// de una pantalla. Cada `labelKey` que aquel fichero declara tiene aquí su
// traducción en los cuatro idiomas, y una que falte no rompe nada — sale el id
// hecho legible, en inglés, en medio de una pantalla en castellano.
//
// La ayuda de un dataset (`help`) es lo que alguien lee en el desplegable de
// Explorar antes de elegirlo. Dice qué es UNA FILA, que es la pregunta que de
// verdad distingue dos conjuntos de datos parecidos.

const analytics = {
  es: {
    orders: {
      label: 'Órdenes de trabajo',
      help: 'Una fila por orden de trabajo. Para horas por día o por persona, usa los partes',
    },
    hours: {
      label: 'Partes de trabajo',
      help: 'Una fila por parte: quién trabajó, cuántas horas y qué día',
    },
    dates: {
      planned: 'Fecha prevista',
      completed: 'Fecha de cierre',
      started: 'Fecha de inicio',
      created: 'Fecha de alta',
      workDate: 'Día trabajado',
    },
    metrics: {
      orders: 'Órdenes',
      open: 'Abiertas',
      completed: 'Cerradas',
      late: 'Fuera de plazo',
      hours: 'Horas imputadas',
      incidents: 'Incidencias',
      openIncidents: 'Incidencias sin resolver',
      incidentRate: 'Incidencias por 100 órdenes',
      hoursPerOrder: 'Horas por orden',
      daysToComplete: 'Días respecto a lo previsto',
      reportedHours: 'Horas de campo',
      reports: 'Partes',
      averageDay: 'Horas por parte',
    },
    dimensions: {
      status: 'Estado',
      origin: 'Origen',
      customer: 'Cliente',
      project: 'Obra',
      assignee: 'Responsable',
      kind: 'Tipo de trabajo',
      priority: 'Prioridad',
      location: 'Emplazamiento',
      worker: 'Quién trabajó',
      order: 'Orden de trabajo',
    },
    filters: {
      hours: 'Horas imputadas',
      reportHours: 'Horas del parte',
    },
  },
  ca: {
    orders: {
      label: 'Ordres de treball',
      help: 'Una fila per ordre de treball. Per a hores per dia o per persona, fes servir els parts',
    },
    hours: {
      label: 'Parts de treball',
      help: 'Una fila per part: qui va treballar, quantes hores i quin dia',
    },
    dates: {
      planned: 'Data prevista',
      completed: 'Data de tancament',
      started: 'Data d\'inici',
      created: 'Data d\'alta',
      workDate: 'Dia treballat',
    },
    metrics: {
      orders: 'Ordres',
      open: 'Obertes',
      completed: 'Tancades',
      late: 'Fora de termini',
      hours: 'Hores imputades',
      incidents: 'Incidències',
      openIncidents: 'Incidències sense resoldre',
      incidentRate: 'Incidències per 100 ordres',
      hoursPerOrder: 'Hores per ordre',
      daysToComplete: 'Dies respecte al previst',
      reportedHours: 'Hores de camp',
      reports: 'Parts',
      averageDay: 'Hores per part',
    },
    dimensions: {
      status: 'Estat',
      origin: 'Origen',
      customer: 'Client',
      project: 'Obra',
      assignee: 'Responsable',
      kind: 'Tipus de treball',
      priority: 'Prioritat',
      location: 'Emplaçament',
      worker: 'Qui va treballar',
      order: 'Ordre de treball',
    },
    filters: {
      hours: 'Hores imputades',
      reportHours: 'Hores del part',
    },
  },
  en: {
    orders: {
      label: 'Work orders',
      help: 'One row per work order. For hours by day or by person, use the field reports',
    },
    hours: {
      label: 'Field reports',
      help: 'One row per report: who worked, how long and on which day',
    },
    dates: {
      planned: 'Planned date',
      completed: 'Completed',
      started: 'Started',
      created: 'Raised',
      workDate: 'Work date',
    },
    metrics: {
      orders: 'Orders',
      open: 'Open',
      completed: 'Completed',
      late: 'Late',
      hours: 'Hours booked',
      incidents: 'Incidents',
      openIncidents: 'Unresolved incidents',
      incidentRate: 'Incidents per 100 orders',
      hoursPerOrder: 'Hours per order',
      daysToComplete: 'Days against plan',
      reportedHours: 'Field hours',
      reports: 'Reports',
      averageDay: 'Hours per report',
    },
    dimensions: {
      status: 'Status',
      origin: 'Origin',
      customer: 'Customer',
      project: 'Job',
      assignee: 'Lead',
      kind: 'Kind of work',
      priority: 'Priority',
      location: 'Location',
      worker: 'Worker',
      order: 'Work order',
    },
    filters: {
      hours: 'Hours booked',
      reportHours: 'Hours on the report',
    },
  },
  fr: {
    orders: {
      label: 'Ordres de travail',
      help: 'Une ligne par ordre de travail. Pour les heures par jour ou par personne, utilisez les rapports',
    },
    hours: {
      label: 'Rapports de chantier',
      help: 'Une ligne par rapport : qui a travaillé, combien de temps et quel jour',
    },
    dates: {
      planned: 'Date prévue',
      completed: 'Date de clôture',
      started: 'Date de début',
      created: 'Date de création',
      workDate: 'Jour travaillé',
    },
    metrics: {
      orders: 'Ordres',
      open: 'Ouverts',
      completed: 'Terminés',
      late: 'En retard',
      hours: 'Heures imputées',
      incidents: 'Incidents',
      openIncidents: 'Incidents non résolus',
      incidentRate: 'Incidents pour 100 ordres',
      hoursPerOrder: 'Heures par ordre',
      daysToComplete: 'Jours par rapport au prévu',
      reportedHours: 'Heures de terrain',
      reports: 'Rapports',
      averageDay: 'Heures par rapport',
    },
    dimensions: {
      status: 'Statut',
      origin: 'Origine',
      customer: 'Client',
      project: 'Chantier',
      assignee: 'Responsable',
      kind: 'Type de travail',
      priority: 'Priorité',
      location: 'Lieu',
      worker: 'Intervenant',
      order: 'Ordre de travail',
    },
    filters: {
      hours: 'Heures imputées',
      reportHours: 'Heures du rapport',
    },
  },
}

/**
 * Adds the analytics vocabulary to the module's own catalogue, locale by locale.
 *
 * Merged here rather than pasted into the big literal so the block stays
 * readable and so adding a metric is one line in two files instead of four
 * edits in the middle of eight hundred.
 */
export function withAnalytics(base, namespace) {
  const merged = {}
  for (const [locale, catalogue] of Object.entries(base)) {
    merged[locale] = {
      ...catalogue,
      [namespace]: { ...catalogue[namespace], analytics: analytics[locale] },
    }
  }
  return merged
}

export default analytics
